var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4"},[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v("The page you're attempting to access does not exist. Please make sure your URL has no mistakes.")])])
}]

export { render, staticRenderFns }